export const PHARMACY_DIAGNOSTICS_SERVICE_GROUP_ID = 1;
export const HOMECARE_DIAGNOSTICS_SERVICE_GROUP_ID = 4;
export const FACE_TO_FACE_CONSULTATION_SERVICE_GROUP_ID = 8;